import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, Tooltip, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import MaterialTable from 'material-table';
import { MuiTableRows } from '../../../themes';
import { BackButton, localization } from '../../sc-utilities';
import * as actions from './store/activeCustomerActions';
import * as action from '../../np-core/Auth/store/authActions';
import moment from 'moment';

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16
    },
    customToolbar: {
        marginLeft: 14,
        width: "900px"
    }
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const ActiveCustomerList = props => {
    const { classes, translations, onFetchCustomers, onCustomersCount, fetching, saveColumnsFilter, activeCustomerID, tableColumns, activeCustomer, tableRef } = props;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []);

    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        selection: false,
        search: false,
        minBodyHeight: window.innerHeight - 205 < 300 ? 300 : window.innerHeight - 205,
        maxBodyHeight: window.innerHeight - 205,
        pageSizeOptions: rowsPageSizeInit,
        exportButton: false,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
        },
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        q['CreatedAt'] = q['CreatedAt'] ? moment(q['CreatedAt']).set({ hour: 0, minute: 0, second: 0 }).format('YYYY-MM-DD HH:mm:ss') : null;
        query['ActiveCustomerID'] = activeCustomerID;
        query['listInactive'] = true;
        query['q'] = q;
        let count = await onCustomersCount(query);

        let result = count ? await onFetchCustomers(query) : [];
        let filteredArray = result.filter((customer) => activeCustomerID !== customer.CustomerID);
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: activeCustomer? [activeCustomer, ...filteredArray] : filteredArray, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography className={classes.typography}>{translations["associated_customers"] || 'Associated customers'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`ActiveCustomer`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    }

    return (
        <Paper>
            <MaterialTable
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                data={fetchTableData}
                options={tableOptions}
                isLoading={fetching}
                localization={localization(translations)}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}
                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state.core.login.activeCustomer,
        activeCustomerID: state.core.login.activeCustomer?.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        fetching: state.activeCustomer.activeCustomer.fetching,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCustomersCount: filter => dispatch(actions.fetchCustomersCount(filter)),
        onFetchCustomers: filter => dispatch(actions.fetchCustomers(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ActiveCustomerList));